import type { AuthConfigStatus } from '../widget-lib/smartcaptcha';

type Props = {
  /** Серверная капча включена (даже если IP в bypass) — юридическое уведомление обязательно. */
  serverEnabled: boolean;
  challengeVisible?: boolean;
  /** loading/error показывают состояние конфига; по умолчанию — готово. */
  status?: AuthConfigStatus;
  onRetry?: () => void;
};

/**
 * Уведомление об обработке данных SmartCaptcha (обязательно по правилам сервиса).
 * В невидимом режиме штатный щит Яндекса скрыт (hideShield) — уведомление показываем здесь.
 * Пока конфиг грузится, submit блокируется и здесь видна подсказка; при ошибке — кнопка повтора.
 */
export function SmartCaptchaNotice({ serverEnabled, challengeVisible, status = 'ready', onRetry }: Props) {
  if (status === 'ready' && !serverEnabled) return null;
  return (
    <div className="space-y-1 text-center">
      {status === 'loading' ? (
        <p className="m-0 text-xs text-[var(--text-muted)]" role="status" aria-live="polite">
          Проверяем защиту от роботов…
        </p>
      ) : null}
      {status === 'error' ? (
        <p className="m-0 text-xs text-[var(--text-muted)]" role="status" aria-live="polite">
          Не удалось проверить защиту от роботов.{' '}
          {onRetry ? (
            <button
              type="button"
              className="underline underline-offset-2 hover:text-[var(--text)]"
              onClick={onRetry}
            >
              Повторить
            </button>
          ) : null}
        </p>
      ) : null}
      {status === 'ready' && challengeVisible ? (
        <p className="m-0 text-xs text-[var(--text)]" role="status" aria-live="polite">
          Пройдите проверку, чтобы продолжить.
        </p>
      ) : null}
      {status === 'ready' ? (
        <p className="m-0 text-[11px] leading-snug text-[var(--text-muted)]">
          Защищено{' '}
          <a
            href="https://yandex.ru/legal/smartcaptcha_notice/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2"
          >
            Yandex SmartCaptcha
          </a>
        </p>
      ) : null}
    </div>
  );
}
